import ZigbeeDevicesManagement from "./components/zigbee-devices/zigbee-devices";

export default function Zigbee2MqttParentCustomConfig() {
  return (
    <>
      <ZigbeeDevicesManagement />
    </>
  );
}
